import React from "react";

const FixedItems = () => {
  return (
    <div>
      <div className="social-icons">
        <div className="facebook social-stag">
          <a
            href="https://www.facebook.com/Medicapcare"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>
        </div>
        <div className="twitter social-stag">
          <a
            href="https://www.twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Twitter
          </a>
        </div>
        <div className="linkedin social-stag">
          <a
            href="https://www.linkedin.com/company/medicaps/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Linkedin
          </a>
        </div>
      </div>
    </div>
  );
};

export default FixedItems;
